import {ReduxStateType} from '../store';

export const selectTaxProfileStatesInfo = (state: ReduxStateType) => {
  return state.taxProfileStatesInfo;
};
